/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Billing_Events_Pagination_PageInputs */

const es_billing_events_pagination_page = /** @type {(inputs: Billing_Events_Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

const en_billing_events_pagination_page = /** @type {(inputs: Billing_Events_Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Billing_Events_Pagination_PageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_events_pagination_page = /** @type {((inputs: Billing_Events_Pagination_PageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Events_Pagination_PageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_events_pagination_page(inputs)
	return en_billing_events_pagination_page(inputs)
});
export { billing_events_pagination_page as "billing.events.pagination.page" }